import { render, staticRenderFns } from "./ListAds.vue?vue&type=template&id=38f996d6&scoped=true"
import script from "./ListAds.vue?vue&type=script&lang=js"
export * from "./ListAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f996d6",
  null
  
)

export default component.exports